import { absolutePath } from "../../../absolutePath";

export const paywallCheckoutAttempt = {
  show: (fingerprint: string) =>
    absolutePath(`paywalls/checkout/attempts/${fingerprint}`),
};
